module.exports = __webpack_public_path__ + "img/40.f3e76fcb.jpg";